import Script from 'next/script';

const isProd = process.env.NEXT_PUBLIC_VERCEL_ENV === 'production';

export default function HirematicPixel() {
  return (
    <Script strategy="lazyOnload" id="hirematicScript">
      {isProd
        ? `(function(hire, ma, tic) {
    window.ppln = function(){(window.ppln.q=window.ppln.q||[]).push(arguments);};
    var s = document.createElement('script');
    s.async = 1;
    s.src = hire + '?i=' + encodeURIComponent(ma) + '&t=' + Math.ceil(new Date() / parseInt(tic, 10)) * parseInt(tic, 10) + '&r=' + encodeURIComponent(window.location.href);
    var cs = document.getElementsByTagName('script')[0];
    cs.parentNode.insertBefore(s, cs);
    window.ppln('init', ma);
} ('https://cdn.ppln.io/p/c/latest/t/dadf5ed8/ppln.min.js', 'JX-SVDCM-D6UVXU0', '60000'));`
        : `(function(hi, re, ma, tic) {
        // setup the queue to collect all of the calls to ppln.js before it is loaded
        window.ppln = function(){(window.ppln.q=window.ppln.q||[]).push(arguments);};
        // create a script tag
        var s = document.createElement('script');
        s.async = 1;
        s.src = hi + '?i=' + encodeURIComponent(re) + '&t=' + Math.ceil(new Date() / parseInt(ma, 10)) * parseInt(ma, 10) + '&r=' + encodeURIComponent(window.location.href);
        // get the first <script> that occurs in the document
        var cs = document.getElementsByTagName('script')[0];
        cs.parentNode.insertBefore(s, cs);
        // init script
        window.ppln('init', re, tic); 
    } ('https://cdn.ppln.dev/p/c/latest/t/dadf5ed8/ppln.min.js', 'JQ-QUPJJ-NMS9RC9', '60000', {
        endpoint: 'https://pipelin-http-api.data.jobtome.host/v1/t',
        debug: true
    }));
      `}
    </Script>
  );
}

export const trackEvent = (step: 'start' | 'end') => {
  isProd && window?.ppln('track', 'conversionRegistered', { step });
};
